// 移动端 sticky header 的「向下滚动收起分类行」规则。
//
// 抽成纯函数是为了能真的测到它：这套逻辑全是边界条件（顶部附近、方向反转、
// 橡皮筋回弹的负 scrollY、以及下面这个反馈回路），在浏览器里手动试基本试不全。
//
// 两个坑，都是实测才发现的：
//
// 1. 不能按「这一次比上一次高就收起」判断。首页的 scrollY 会自己持续抖动
//    （590→588→582→585→593→599→595→576…），因为图片陆续加载会改变文档高度。
//    所以改成累计位移：同方向走够 TRAVEL 才翻转，方向一变就重新累计。
//
// 2. 收起这个动作本身会引起滚动。分类行在文档流里，收起来文档就矮了 ~25px，
//    浏览器的 scroll anchoring 为了让内容看起来不动，会把 scrollY 也往回夹 25px。
//    那个回夹和用户往上滚是一模一样的事件，于是立刻又展开、又变高、又收起——
//    实测 100ms 翻一次，无限循环。所以翻转之后要锁一小段时间，
//    这段时间里只更新基准位置、不判断方向，等我们自己引起的那波滚动过去。

// 滚过这个距离之前一律保持展开——否则页面刚往下挪一点分类就没了。
export const COLLAPSE_AFTER = 80

// 同方向累计走够这么多像素才翻转。要明显大于抖动幅度（实测约 ±10px）。
export const TRAVEL = 24

// 翻转后的静默期，要盖过 CSS 里那 0.2s 的过渡，否则回夹会被当成用户滚动。
export const SETTLE_MS = 320

export const initialNavState = (y = 0) => ({ collapsed: false, prevY: y, acc: 0, lockedUntil: 0 })

/**
 * @param {{collapsed: boolean, prevY: number, acc: number, lockedUntil: number}} state
 * @param {number} y 这一次的 scrollY
 * @param {number} now 当前时间戳（毫秒）
 */
export function nextNavState(state, y, now) {
  // 顶部附近永远展开。也顺带兜住 iOS 往上拽出来的负数。
  // 放在锁之前：回到顶部这件事任何时候都该立刻生效。
  if (y <= COLLAPSE_AFTER) {
    return state.collapsed
      ? { collapsed: false, prevY: y, acc: 0, lockedUntil: now + SETTLE_MS }
      : { ...state, prevY: y, acc: 0 }
  }

  // 静默期内只更新基准，不判断方向——这段滚动是我们自己造出来的
  if (now < state.lockedUntil) return { ...state, prevY: y, acc: 0 }

  const delta = y - state.prevY
  // 方向和已累计的相反就从头算起，抖动因此永远攒不够 TRAVEL
  const sameDirection = state.acc === 0 || (delta > 0) === (state.acc > 0)
  const acc = sameDirection ? state.acc + delta : delta

  if (acc >= TRAVEL && !state.collapsed) {
    return { collapsed: true, prevY: y, acc: 0, lockedUntil: now + SETTLE_MS }
  }
  if (acc <= -TRAVEL && state.collapsed) {
    return { collapsed: false, prevY: y, acc: 0, lockedUntil: now + SETTLE_MS }
  }
  // 走够了但状态本来就对，把累计清掉，别让它一直涨
  if (acc >= TRAVEL || acc <= -TRAVEL) return { ...state, prevY: y, acc: 0 }

  return { collapsed: state.collapsed, prevY: y, acc, lockedUntil: state.lockedUntil }
}
